if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.onOpenPopupModelViewer();
      this.floadingcart();
    }
  
    onOpenPopupModelViewer() {
      $( document ).ready(function() {
          $('.product-media-item').unbind();
          $('.product-media-item').click(function(){
            var media_id = 'model_viewer_popup-' + $(this).data('media-id');
            var obj = $('#' + media_id).find('.detail-content-popup');
            if (obj.data('media-type') == 'external_video') {
              console.log(obj.data('video'));
              if (obj.data('host') == 'youtube'){
                obj.html('<iframe allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen" class="js-youtube" loading="lazy" src="https://www.youtube.com/embed/'+obj.data('video')+'?autoplay=1&controls=1&enablejsapi=1&loop=0&modestbranding=1&playlist='+obj.data('video')+'&playsinline=1&rel=0" frameborder="0"></iframe>');
              }
              if (obj.data('host') == 'vimeo'){
                obj.html('<iframe allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="allowfullscreen" class="js-vimeo" loading="lazy" src="https://player.vimeo.com/video/'+obj.data('video')+'?autoplay=1&byline=0&controls=1&loop=0&playsinline=1&title=0" title="" frameborder="0"></iframe>');
              }
            }
            if (obj.data('media-type') == 'video') {
              if (obj.data('video')) {
                obj.html('<video class="js-product-video" controls loop ><source type="video/mp4" src="'+obj.data('video')+'"></video>');
              }
            }
            if ($('#' + media_id).find('.detail-content-popup').data('media-type') == 'model') {
              
            }
            var model_viewer_popup = new bootstrap.Modal(document.getElementById(media_id), {
              keyboard: false
            });
            model_viewer_popup.show();
            $('#model_viewer_popup').modal();
         });
        
        $('.detail-modal-dialog .btn-close').unbind();
        $('.detail-modal-dialog .btn-close').click(function(){
        	$('.modal-backdrop').remove();
          	$('.detail-content-popup-video').html('');
          	$('body').css('overflow', 'auto');
        });
      }); 
    }

    onSubmitHandler(evt) {
      evt.preventDefault();

      const submitButton = this.querySelector('[type="submit"]');

      submitButton.setAttribute('disabled', true);
      submitButton.classList.add('loading');

      const body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form)),
        sections_url: window.location.pathname
      });

      fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((parsedState) => {
        	document.querySelector('mini-cart').update();
        	$('.product-minincart').addClass('active');
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('disabled');
        });
    }

    floadingcart(){
    	$(window).scroll(function() {
        if (typeof($('.product-float-cart').html()) != 'undefined' && document.documentElement.scrollTop > ($('.product-form-buy').offset().top + $('.product-form-buy').height()) && document.documentElement.scrollTop < ($('.productdetail-container').offset().top) + $('.productdetail-container').height()) {
            $('.product-float-cart').addClass('active');
        }else{
          $('.product-float-cart').removeClass('active');
        }
      });

  	}
  });
}
